import { BrowserRouter, Route, Switch, withRouter, useLocation } from 'react-router-dom';
import React, { useEffect } from "react";
import Home from './Home';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import TradeDashboard from './TradeDashboard';
import OurApproach from './OurApproach';            // <-- NEW IMPORT
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import Header from './components/TradingCommand/Header';
import Footer from './footer';
import Liveview from './Live';
import LiveSocket from './LiveSocket';
import TradingCommand from './TradingCommand';
import DailyDetailDashboard from './DailyDetailDashboard';
import AdminPage from './routes/admin/admin';
import ReactGA from 'react-ga4';
import { initGA, logPageView } from './service/StatCounter';

initGA('G-ES7SDYBBEQ');

const TrackedRoute = withRouter(Route);

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    console.log("location:", location);
    logPageView(location.pathname);
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <div className="content">
          <Switch>
            <TrackedRoute exact path="/"           component={Home} />
            <TrackedRoute exact path="/Home"       component={Home} />
            <TrackedRoute path="/approach"         component={OurApproach} />  {/* NEW ROUTE */}
            <TrackedRoute path="/Signup"           component={Register} />
            <TrackedRoute path="/Login"            component={Login} />
            <TrackedRoute path="/Dashboard"        component={Dashboard} />
            <TrackedRoute path="/trading"          component={TradeDashboard} />
            <TrackedRoute path="/DailyDetail"      component={DailyDetailDashboard} />
            <TrackedRoute path="/Live"             component={LiveSocket} />
            <TrackedRoute path="/Live-New"         component={TradingCommand} />
            <TrackedRoute path="/Admin"            component={AdminPage} />
          </Switch>
          <RouteTracker />
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;